export const acceptedFileTypes = [
  "image/jpeg",
  "image/png",
  "application/pdf",
  "image/gif",
  "image/webp",
];
